export const CATEGORY_CREATE = "categoryCreate";
export const CATEGORY_EDIT = "categoryEdit";
export const CATEGORY_DELETE = "categoryDelete";
export const CATEGORY_GET = "categoryGet";
export const CATEGORIES_GET = "categoriesGet";
